import * as React from 'react';
import * as cx from 'classnames';
import ProcessIndicatorItem, {
  Props as ItemComponentProps,
} from './ProcessIndicatorItem';

interface Item {
  title?: string;
  done?: boolean;
  active?: boolean;
  key?: string;
  content?: React.ReactNode;
}

const getReducer = (len: number, lineClassName?: string) => (
  acc: React.ReactNode[],
  item: React.ReactNode,
  i: number,
) => [
  ...acc,
  ...(i < len - 1
    ? [
        item,
        <div
          key={`indicator-${i}`}
          className={cx('process-indicator__line', lineClassName)}
        />,
      ]
    : [item]),
];

interface Props {
  children?: React.ReactNode;
  ItemComponent?: React.ComponentType<ItemComponentProps>;
  className?: string;
  lineClassName?: string;
  align?: 'vertical' | 'horizontal';
  titlePosition?: 'top' | 'bottom' | 'left' | 'right';
  showTitle?: boolean;
  items?: Item[];
}

const ProcessIndicator: React.SFC<Props> = ({
  children = null,
  items = [],
  align = 'horizontal',
  titlePosition = 'bottom',
  ItemComponent = ProcessIndicatorItem,
  showTitle = true,
  className = '',
  lineClassName,
}) => {
  let content = null;

  if (items.length > 0) {
    content = items
      .map(item => (
        <ItemComponent
          key={item.key || item.title}
          showTitle={showTitle}
          titlePosition={titlePosition}
          {...item}
        >
          {item.content}
        </ItemComponent>
      ))
      .reduce(getReducer(items.length, lineClassName), []);
  } else {
    const childrenArray = React.Children.toArray(children);

    content =
      childrenArray.length > 1
        ? childrenArray.reduce(
            getReducer(childrenArray.length, lineClassName),
            [],
          )
        : childrenArray;
  }

  return (
    <div
      className={cx(
        'process-indicator',
        {
          [`process-indicator--${align}`]: Boolean(align),
        },
        className,
      )}
    >
      {content}
    </div>
  );
};

export default ProcessIndicator;
